<template>
  <div class="login-container">
    <div class="login-bg"></div>
    <div class="login-form-wrapper">
      <div class="login-form">
        <h2 class="login-title">欢迎登录</h2>
        <el-form ref="loginFormRef" :model="loginForm" :rules="rules" class="login-form">
          <el-form-item prop="username">
            <el-input
              v-model="loginForm.username"
              placeholder="请输入账号"
              prefix-icon="el-icon-user"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              type="password"
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleLogin" style="width: 100%;">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import userAPI from '@/api/user.js'

const router = useRouter()
const loginForm = reactive({
  username: '',
  password: ''
})

const rules = {
  username: [
    { required: true, message: '请输入账号', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' }
  ]
}

const loginFormRef = ref(null)

// 添加键盘监听事件，按下回车键触发登录
const handleKeyDown = (event) => {
  if (event.key === 'Enter') {
    handleLogin()
  }
}

// 组件挂载时添加事件监听
onMounted(() => {
  document.addEventListener('keydown', handleKeyDown)
})

// 组件卸载时移除事件监听
onUnmounted(() => {
  document.removeEventListener('keydown', handleKeyDown)
})

const handleLogin = () => {
  loginFormRef.value.validate((valid) => {
    if (valid) {
      // 调用登录API进行验证
      userAPI.login(loginForm).then(data => {
        // 登录成功，response拦截器已处理code=0的情况并直接返回data
        // 保存登录状态和token
        localStorage.setItem('isLoggedIn', 'true')
        localStorage.setItem('username', loginForm.username)
        localStorage.setItem('token', data.userToken)
        
        // 显示登录成功提示
        ElMessage.success('登录成功')
        
        // 跳转到证书列表页面
        router.push('/certificates')
      }).catch(error => {
        // 处理请求错误，error.message中包含了响应拦截器提取的错误信息
        ElMessage.error(error.message || '登录请求失败，请稍后重试')
        console.error('Login error:', error)
      })
    }
  })
}
</script>

<style scoped>
.login-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--bg-primary);
}

.login-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/assets/images/login-background.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.login-form-wrapper {
  position: fixed; /* 更改为固定定位 */
  right: 25%; /* 距离右边界的距离 */
  bottom: 25%; /* 距离下边界的距离 */
  background: var(--bg-secondary);
  border-radius: 12px;
  padding: 50px 40px;
  box-shadow: var(--shadow-base);
  min-width: 360px;
  z-index: 10;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.login-form-wrapper:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

.login-title {
  text-align: center;
  margin-bottom: 35px;
  color: var(--text-primary);
  font-size: 24px;
  font-weight: 600;
}

.login-form {
  width: 100%;
}

:deep(.el-input) {
  margin-bottom: 24px;
  border-radius: 8px;
}

:deep(.el-input__wrapper) {
  border-radius: 8px;
  border: 1px solid var(--border-color);
  transition: all 0.3s ease;
}

:deep(.el-input__wrapper:hover) {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

:deep(.el-input__wrapper.is-focus) {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

:deep(.el-button--primary) {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  border-radius: 8px;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
}

:deep(.el-button--primary:hover) {
  background-color: #66b1ff;
  border-color: #66b1ff;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

:deep(.el-button--primary:active) {
  transform: translateY(0);
}
</style>